import { makeStyles } from "@material-ui/core/styles";

export const useOtpStyles = makeStyles(() => ({
  container: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    gap: "30px",
    transition: "all 0.3s ease-in-out",
  },

  otpContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "8px",
    marginTop: "10px",
  },

  otpInput: {
    width: "40px",
    height: "45px",
    textAlign: "center",
    fontSize: "20px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    outline: "none",
    "&:focus": {
      border: "2px solid #05A5FF",
    },
  },

  resendText: {
    textAlign: "center",
    fontSize: "13px",
    color: "#666",
    marginBottom: 15,
  },

  resendButton: {
    cursor: "pointer",
    color: "#4caf50",
    fontWeight: "bold",
    "&:disabled": {
      color: "#aaa",
      cursor: "not-allowed",
    },
    marginBottom: 15,
  },

// ********** STEP 2 INPUT CODE ***********
  titleStep: {
    color: "#1E375A",
    fontSize: 28,
    fontStyle: "normal",
    fontWeight: 700,
  },

  description: {
    color: "#1e375ab3",
    fontSize: 18,
    fontStyle: "normal",
    fontWeight: 500,
    letterSpacing: 0.36
  },

  verifyButton: {
    width: 250,
    height: 45,
    borderRadius: 10,
    background: "#05A5FF",
    letterSpacing: 3,
    boxShadow: `0 14px 38px 0 rgba(35, 100, 210, 0.20);`,
    marginBottom: 15,
  },

  errorMessage:{
    color: "#d32f2f",
    backgroundColor: "#fdecea",
    padding: "6px 10px",
    borderRadius: "6px",
    marginTop: "10px",
    fontSize: "0.85rem",
    textAlign: "center",
  },

  linkStyle:{
    color: "#00174b",
    fontWeight: 600,
  }

}));
